import { useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { FileUpload } from '@/features/files'
import Title from './Title'
import InputTile from './InputTile'

export default function Font() {
  const { t } = useLingui()

  return (
    <InputTile>
      <Title
        title={t`font`}
        description={t`The font of your Brand, the Guest-App will use this font in the Guest-App.`}
      />
      <Form.Field name="fontMedium" label={t`Heading Font`} size="small">
        {({ renderProps: { onChange, ...props } }) => (
          <FileUpload
            className="h-20 w-48"
            objectFit="contain"
            accept="font/*"
            onChange={onChange}
            onRemove={() => onChange(null)}
            placeholder={t`Choose a font for headings`}
            {...props}
          />
        )}
      </Form.Field>
      <Form.Field name="fontRegular" label={t`Standard Font`} size="small">
        {({ renderProps: { onChange, ...props } }) => (
          <FileUpload
            className="h-20 w-48"
            objectFit="contain"
            accept="font/*"
            onChange={onChange}
            onRemove={() => onChange(null)}
            placeholder={t`Choose a font for standard text`}
            {...props}
          />
        )}
      </Form.Field>
    </InputTile>
  )
}
